import React from 'react';

import { Typography } from '@material-ui/core';

const ErrorTypographyComponent = ({ error }) => <Typography>{(error && error.message) || error}</Typography>;

export const ErrorTypography = ErrorTypographyComponent;
